"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get AuthenticationResponse () {
        return AuthenticationResponse;
    },
    get UserPrimaryRoleEnum () {
        return UserPrimaryRoleEnum;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const UserPrimaryRoleEnum = _zod.z.union([
    _zod.z.literal("billing-admin"),
    _zod.z.literal("admin"),
    _zod.z.literal("basic-admin"),
    _zod.z.literal("any-employee")
]);
const AuthenticationResponse = _zod.z.object({
    token: _zod.z.string(),
    userId: _zod.z.instanceof(_bson.ObjectId),
    companyId: _zod.z.instanceof(_bson.ObjectId),
    primaryRole: UserPrimaryRoleEnum
});
